import React from 'react';
import { MedelyLogo } from '@medely/web-components/icons';
import { CompanyLogo } from './CompanyLogo';

type LogoCompany = {
  name: string;
  logo?: string;
};

interface LogoProps {
  isSaasAccount?: boolean;
  company?: LogoCompany;
  width?: string;
  height?: string;
}

export const Logo: React.FC<LogoProps> = ({ isSaasAccount, company, ...props }) => {
  return isSaasAccount && company ? (
    <CompanyLogo company_name={company.name} logo={company.logo ?? ''} />
  ) : (
    <MedelyLogo {...props} />
  );
};
